<template>
<div>
  <el-tabs class="tab-button" v-model="activeTabName" @tab-click="changeActiveTab">
    <!-- 과점유 SQL (Oracle) -->
    <el-tab-pane :label="tabs.oligopolyQuery.label" :name="tabs.oligopolyQuery.name" v-if="isOracle">
      <w-oligopoly-query :ref="tabs.oligopolyQuery.name" :operation-flag="operationFlag" :active="tabs.oligopolyQuery.active" />
    </el-tab-pane>
    <!-- 데몬 프로세스 -->
    <el-tab-pane :label="tabs.demonProcess.label" :name="tabs.demonProcess.name">
      <w-demon-process :ref="tabs.demonProcess.name" :operation-flag="operationFlag" :active="tabs.demonProcess.active" />
    </el-tab-pane>
    <!-- DB 세션 -->
    <el-tab-pane :label="tabs.dbSession.label" :name="tabs.dbSession.name">
      <w-db-session :ref="tabs.dbSession.name" :operation-flag="operationFlag" :active="tabs.dbSession.active" />
    </el-tab-pane>
    <!-- 메모리 정보 -->
    <el-tab-pane :label="tabs.memoryInfo.label" :name="tabs.memoryInfo.name">
      <w-memory-info :ref="tabs.memoryInfo.name" :operation-flag="operationFlag" :active="tabs.memoryInfo.active" />
    </el-tab-pane>
    <!-- 공간 사용률 -->
    <el-tab-pane :label="tabs.spaceUtilization.label" :name="tabs.spaceUtilization.name">
      <w-space-utilization :ref="tabs.spaceUtilization.name" :operation-flag="operationFlag" :active="tabs.spaceUtilization.active" />
    </el-tab-pane>
    <!-- HOST 성능 -->
    <el-tab-pane :label="tabs.hostPerformance.label" :name="tabs.hostPerformance.name">
      <w-host-performance :ref="tabs.hostPerformance.name" :operation-flag="operationFlag" :active="tabs.hostPerformance.active" />
    </el-tab-pane>
    <!-- <el-tab-pane label="DB 로그" name="">
    </el-tab-pane> -->
    <!-- DB Lock -->
    <el-tab-pane :label="tabs.lock.label" :name="tabs.lock.name" v-if="isOracle">
      <w-db-lock :ref="tabs.lock.name" :operation-flag="operationFlag" :active="tabs.lock.active" />
    </el-tab-pane>
    <el-tab-pane :label="tabs.oraclePlus.label" :name="tabs.oraclePlus.name"  v-if="isOracle">
      <w-oracle-plus :ref="tabs.oraclePlus.name" :operation-flag="operationFlag" :active="tabs.oraclePlus.active" />
    </el-tab-pane>
    <el-tab-pane :label="tabs.applog.label" :name="tabs.applog.name" v-if="isLms">
      <w-applog-info-table :ref="tabs.applog.name" :operation-flag="operationFlag" :active="tabs.applog.active"></w-applog-info-table>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import findIndex from 'lodash/findIndex';
import { mapGetters } from 'vuex';
import { proviedDbTypeMap } from '@/constants/dbms';
import WOligopolyQuery from './components/table/OligopolyQuery';
import WDemonProcess from './components/table/DemonProcess';
import WDbSession from './components/table/DbSession';
import WMemoryInfo from './components/table/MemoryInfo';
import WSpaceUtilization from './components/table/SpaceUtilization';
import WHostPerformance from './components/table/HostPerformance';
import WOraclePlus from './components/table/OraclePlus';
import WDbLock from './components/table/DbLock';
import WApplogInfoTable from './components/table/Applog';

export default {
  name: 'WPerformanceDatabaseAnalysisTable',
  components: {
    WOligopolyQuery,
    WDemonProcess,
    WDbSession,
    WMemoryInfo,
    WSpaceUtilization,
    WHostPerformance,
    WOraclePlus,
    WDbLock,
    WApplogInfoTable,
  },
  props: {
    operationFlag: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeTabName: '',
      activeTab: null,
      tabs: {
        oligopolyQuery: {
          name: 'oligopolyQuery',
          label: '과점 SQL문',
          active: false,
        },
        demonProcess: {
          name: 'demonProcess',
          label: '데몬 프로세스',
          active: false,
        },
        dbSession: {
          name: 'dbSession',
          label: 'DB 세션',
          active: false,
        },
        memoryInfo: {
          name: 'memoryInfo',
          label: '메모리 정보',
          active: false,
        },
        spaceUtilization: {
          name: 'spaceUtilization',
          label: '공간 사용률',
          active: false,
        },
        hostPerformance: {
          name: 'hostPerformance',
          label: 'HOST 성능',
          active: false,
        },
        lock: {
          name: 'lock',
          label: 'Lock',
          active: false,
        },
        oraclePlus: {
          name: 'oraclePlus',
          label: 'Oracle +',
          active: false,
        },
        applog: {
          name: 'applog',
          label: '어플리케이션 로그',
          active: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'activeManagetypeIds']),
    isOracle() {
      const objtypeId = this.selectedNode && this.selectedNode.obj ? this.selectedNode.obj.objtypeId : null;
      return objtypeId === proviedDbTypeMap.ORACLE;
    },
    isLms() {
      const idx = findIndex(this.activeManagetypeIds, (item) => item === 'LMS');
      return (idx !== -1);
    },
  },
  watch: {
    selectedNode: {
      handler() {
        if (!this.isOracle && this.isOracleTab(this.activeTabName)) {
          this.activeTabName = this.tabs.demonProcess.name;
          this.changeActiveTab();
        } else if (this.operationFlag) {
          this.$nextTick(() => {
            this.$refs[this.activeTabName].loadData();
          });
        }
      },
    },
    active: {
      handler(flag) {
        // [운영 탭] 기존 분석탭은 차트에서 loadData 하는 구조였기에 운영탭에서는 아래와 같이 ref를 이용하여 직접 loadData한다.
        if (flag && this.operationFlag) {
          this.$refs[this.activeTab.name].loadData();
        }
      },
    },
  },
  mounted() {
    this.activeTabName = this.isOracle ? this.tabs.oligopolyQuery.name : this.tabs.demonProcess.name;
    this.changeActiveTab(this.activeTabName);
  },
  methods: {
    changeActiveTab() {
      const activeTab = this.tabs[this.activeTabName];
      activeTab.active = true;
      if (!isNil(this.activeTab)) {
        this.activeTab.active = false;
      }
      this.activeTab = activeTab;
      // 운영 탭에서 하위 탭들 loadData 수행
      if (this.operationFlag && this.active) {
        this.$nextTick(() => {
          this.$refs[activeTab.name].loadData();
        });
      }
    },
    isOracleTab(tabName) {
      return tabName === this.tabs.oligopolyQuery.name || tabName === this.tabs.oraclePlus.name || tabName === this.tabs.lock.name;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/PerformanceDatabaseAnalysisTable.vue